// extracted by mini-css-extract-plugin
module.exports = {"dialogue-box-wrapper":"_30nmm0GbkCbmC8W5PpRtWI","dialogue-box":"_2zvVSKg9GsJGvABDHm7I9O","letter":"_2AMT63RlppzpJhZ2o0th6_","fadeIn":"_1ckPNvkD7_lKkzyMt5AGyh"};